// extracted by mini-css-extract-plugin
export var lg = "_2d-4";
export var md = "_2d-3";
export var sm = "_2d-2";
export var xs = "_2d-1";
export var xxs = "_2d-0";